import gql from 'graphql-tag'

const languages = JSON.parse(process.env.VUE_APP_I18N_LANGUAGES || ["DE","EN"]).map(lang => lang.toUpperCase());
const titleFields = languages.map(lang => `title${lang.charAt(0)}${lang.slice(1).toLowerCase()}`).join('\n');
const textFields = languages.map(lang => `text${lang.charAt(0)}${lang.slice(1).toLowerCase()}`).join('\n');

export const URGENT_CUSTOMER_NEWS_QUERY = gql`
query UrgentCustomerNews($limit: Int) {
  urgentCustomerNews(limit: $limit) {
    results {
      id
      text
      title
      ${titleFields}
      ${textFields}
      newsType
      createdAt
      significantUpdateAt
    }
  }
}
`
